import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-service-details',
  templateUrl: './off-grid-solar.component.html',
  styleUrls: ['./off-grid-solar.component.scss']
})
export class OffGridSolarComponent implements OnInit {

  constructor(private titleService: Title) { }
  
    ngOnInit() {
       this.titleService.setTitle('Off Grid Solar');
    }

}
